import actions from '@wc-stripe/actions';

if (typeof wc_stripe_german_market_params !== 'undefined') {
    if (wc_stripe_german_market_params.second_checkout === 'on') {
        actions.addFilter('wc_stripe_should_create_payment_method', (value) => {
            if (!value) {
                value = true;
            }
            return value;
        });
    }
}